<app-service-detail>
    <app-variables-tabs primarySelectedTab="CrossTables" class="container-fluid px-5">
    </app-variables-tabs>
    <div class="col-12 pl-md-5 ml-auto list-header">

        <h1 class="list-header-title">
            {{'Fields / Properties' | translate}}
            <span 
                class="editBtn btn-field position ml-2"
                (click)="showFieldsGenerator = true">
                {{ ' Generate fields ' | translate }}
            </span>
        </h1>
    </div>
    <div class="col-12 pl-5">
        <div class="row">
            <div class="col-md-12">
                <section class="table-container">
                <section class="table-flip-scroll">
                    <table *ngIf="formFieldProperties.length"
                    class="table table-bordered table-striped cross-table fields-regs">
                            <thead>
                                <tr>
                                    <th>{{'crosstables.form_field' | translate}}</th>
                                    <th *ngFor="let item of formFieldProperties[0];">
                                        <span class="limited" title="{{ item.propertyName}}">
                                            {{ item.propertyName}}
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <fields-group-property 
                                    *ngFor="let group of formFieldsGroup;"
                                    [group]="group"
                                    [properties]="formFieldProperties"></fields-group-property>
                            </tbody>
                        </table>
                </section>
            </section>
            </div>
        </div>
    </div>

    <fields-generator *ngIf="showFieldsGenerator"
            (modalClosedEvent)="showFieldsGenerator = false"
            [embedded]="true"
            [ngStyle]="style"
            mwlResizable
            [enableGhostResize]="true"
            [resizeEdges]="{ bottom: false, right: false, top: false, left: true }"
            (resizeEnd)="onResizeEnd($event)"
            class="layer half-layer px-3">
    </fields-generator>
</app-service-detail>